import { createFileRoute } from "@tanstack/react-router";
import Funil from "@/pages/admin/Funil";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/funil")({
  head: () => pageHead({ title: "Funil | Painel", path: "/admin/funil", noindex: true }),
  component: Funil,
});
